// Daily trend chart. The SVG is built as a string (see bamsShortsCharts) and injected;
// legend clicks bubble up through `onTrendClick` to toggle facility series.
export function DailyTrendPanel({ onTrendClick, trendHtml, trendRef }) {
    return (
        <div className="panel">
            <p className="ptitle">Daily trend — shorts per order packed</p>
            {/* eslint-disable-next-line react/no-danger */}
            <div ref={trendRef} onClick={onTrendClick} dangerouslySetInnerHTML={{ __html: trendHtml }} />
        </div>
    );
}
